<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-tabs ttRememberId="gb_furniturefabricss_status" [(ttSelectedId)]="setting.gb_furniturefabricss_status" (ttSelectedIdChange)="onTabChange()">
            <tt-tab ttId="ACTIVE" ttLabel="gb_furniturefabricss_status_active"></tt-tab>
            <tt-tab ttId="NOTACTIVE" ttLabel="gb_furniturefabricss_status_notactive"></tt-tab>
            <tt-tab ttId="ALL" ttLabel="gb_furniturefabricss_status_all"></tt-tab>
        </tt-tabs>

        <tt-input ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
        <tt-button-goto [ttText]="'furniturefabricss_new'" (ttClick)="goToFunc('furniturefabrics')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListFurnitureFabrics" [ttFilter]="setting.searchtext"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgFurnitureFabricssStatus.buttons" tt-model="vm.model.bgFurnitureFabricssStatus.selected" tt-change="vm.selectBgFurnitureFabricssStatus($value)"></tt-buttons-radio>
        <tt-input-buttons class="col-xs-12 sp-0" tt-label="searchtext" tt-focus="false" tt-model="vm.model.setting.searchtext" tt-change="vm.model.setting.searchtext = $value" tt-placeholder="" tt-buttons="vm.model.searchTextButtons"></tt-input-buttons>
        <tt-button class="col-xs-12 sp-0" tt-text="furniturefabricss_new" tt-click="vm.goToFunc('furniturefabrics')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListFurnitureFabrics" badge="" ltype="" design-var="s12t0" filter-val="vm.model.setting.searchtext"></im-list-directive>
</tt-page>-->
